import React,{useState, useEffect, Fragment} from "react"
import  "../../../css/style-new.css";
import  "../../../css/developer1.css";
import "../../../css/bootstrap.min.css";
import "../../../css/font.css";
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
import { schoolsurl, foreignexchangelists, eligibility,schoolsApiurl, FileUploadAthletURL } from "../../../apis/urls";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toBeChecked } from "@testing-library/jest-dom/dist/matchers";
import { Alert } from "bootstrap";
import { decode } from "html-entities";
import { Uploader } from "rsuite";



const AddAthlet = () => {

	useEffect( ()=>{

		schools();
		programs();
		SchoolView();
	 },
	
	[] )

	const { id } = useParams();
	let navigate = useNavigate();
	const username = localStorage.getItem('username')

	const [fname,setFname] = useState('');
	const [mname,setMname] = useState('');
    const [lname,setLname] = useState('');
    const [dob,setDob] = useState('');
    const [gender,setGender] = useState('');
    const [grade,setGrade] = useState('');
    const [year_8th,setYear_8th] = useState('');
    const [year_9th,setYear_9th] = useState('');
	const [international_school,setInternational_school] = useState('');

    const [schoollast,setSchoollast] = useState(0);

    const [public_school_name,setPublic_school_name] = useState('');
	const [public_city,setPublic_city] = useState('');
	const [public_state,setPublic_state] = useState('');
	const [public_country,setPublic_country] = useState('');

	const [private_school_name,setPrivate_school_name] = useState('');
	const [private_city,setPrivate_city] = useState('');
	const [private_state,setPrivate_state] = useState('');
	const [private_country,setPrivate_country] = useState('');

	const [home_school,setHome_school] = useState('');
	const [home_city,setHome_city] = useState('');
	const [home_state,setHome_state] = useState('');
	const [home_country,setHome_country] = useState('');

	const [sevp_school,setSevp_school] = useState('');
	const [sevp_city,setSevp_city] = useState('');
	const [sevp_state,setSevp_state] = useState('');
	const [sevp_country,setSevp_country] = useState('');

	const [aesname,setAesName] = useState('');
	const [aescity,setAesCity] = useState('');
	const [aesstate,setAesState] = useState('');
	const [aescountry,setAesCountry] = useState('');

    const [csiet,setCsiet] = useState('');

	//const [gisa,setGisa] = useState('');
	const [school_gisa,setSchool_gisa] = useState('');
	const [school_csit,setSchool_csit] = useState('');
	const [datetransfered,setDatetransfered] = useState('');
	const [unit,setUnit] = useState('');
	const [notes,setNotes] = useState('');
	const [status,setStatus] = useState('');
	const [status1,setStatus1] = useState(0);

	const [inactive, setInactive] = useState('');
	const [deleted, setDeleted] = useState('');	

	const [schresult,setSchresult] = useState([]);
	const [schoolName,setSchoolName] = useState("");
	const [programresult,setProgramresult] = useState([]);

    const [fnameexist, setFNameExist] = useState(false);
	const [lnameexist, setLNameExist] = useState(false);
    const [statusexist, setStatusExist] = useState(false);
	const [aeserror, setAeserror] = useState(false);
	const [typeerror, setTypeerror] = useState(false);
	const [interschool, setInterSchool] = useState(false);

	const [fileSelect, setFileSelect] = useState('');

	const [lastschoolerror, setLastSchoolError] = useState(false);

	const [fnameerror,setFnameerror] = useState(false);
	const [lnameerror,setLnameerror] = useState(false);
	const [doberror,setDoberror] = useState(false);
	const [gendererror,setGendererror] = useState(false);
	const [gradeerror,setGradeerror] = useState(false);
	const [year_8therror,setYear_8therror] = useState(false);
	const [year_9therror,setYear_9therror] = useState(false);
	const [school_gisaerror,setSchool_gisaerror] = useState(false);
	const [datetransferederror,setDatetransferederror] = useState(false);
	const [uniterror,setUniterror] = useState(false);
	const [checkStatus, setCheckStatus] = useState(false);
	const [agee, setAgee] = useState(''); 
	const [aes, setAes] = useState('')
	const [aesPre, setAesPre] = useState('NO');
	const [aesPdf, setAesPdf] = useState('')


	const [open, setOpen] = useState(false);
	const [ type, setType ] = useState('')
	const [openXFR, setOpenXFR] = useState(false);
	const [xfrtype, setXfrType] = useState('');
	const [openInterSchoolForm, setOpenInterSchoolForm] = useState(false)

	const [aesCompleted, setAesCompleted] = useState('');
	const [aesCompletedError, setAesCompletedError] = useState(false);
	const [is8thGrade, setIs8thGrade] = useState('');
	const [is8thGradeError, setIs8thGradeError] = useState(false);
	const [fileUrl8th, setFileUrl8th] = useState('');
	const [fileSelect8th, setFileSelect8th] = useState('');
	const [student8th, setStudent8th] = useState('');
	const [isTransferStudent, setIsTransferStudent] = useState('');
	const [isTransferStudentError, setIsTransferStudentError] = useState(false);

	
	
	
	
	const openSet = () => {
		setOpen(true);
	}
	
	const openType = () => {
		setOpen(false);
		setStatus1('');
	}

	const openInter = () => {
		setOpenInterSchoolForm(true);
	}

	const closeInter = () => {
		setOpenInterSchoolForm(false);
	}


	const AEScompletedtrue = () => {
		setOpenXFR(true);
	}

	const AEScompletedfalse = () => {
		setOpenXFR(false);
	}
	


	
	// const [startDate, setStartDate] = useState(new Date());

	

	const openList = () => {
		setCheckStatus(prevState => !prevState);
	}

	useEffect(() => {

		let dateDropdown = document.getElementById('date-dropdown');

		let currentYear = new Date().getFullYear();
		let earliestYear = 2010;

		while (currentYear >= earliestYear) {
		let dateOption = document.createElement('option');
		dateOption.text = currentYear;
		dateOption.value = currentYear;
		dateDropdown.add(dateOption);
		currentYear -= 1;
		}
		
	},[]);

	useEffect(() => { 

		if(grade >= 9)
		{

		let dateDropdown = document.getElementById('date-dropdown2');

		let currentYear = new Date().getFullYear();
		let earliestYear = 2010;

		while (currentYear >= earliestYear) {
		let dateOption = document.createElement('option');
		dateOption.text = currentYear;
		dateOption.value = currentYear;
		
		dateDropdown.add(dateOption);
		
		currentYear -= 1;
		}
	}
		
	},[grade]);


	const RoutToList = () =>{
        navigate("/school_list/athlet_list/"+id)
    }

	// const calculate_age = dob => {
	// 	const birthDate = new Date(dob); 
	// 	const difference = Date.now() - birthDate.getTime();
	// 	const age = new Date(difference);
	  
	// 	return Math.abs(age.getUTCFullYear() - 1970);

	// 	setAge(age);
	//   }

	//   useEffect(() => {

		
	// 	age_calc();

		
	//   },[]);



	  const age_calc = (year_born) => {
		console.log("year_born", year_born);
		
		setDob(year_born);
		var birthDate = new Date(year_born);
		var currentDate = new Date();
		var age = currentDate.getFullYear() - birthDate.getFullYear();
		setAgee(age);
		if(currentDate.getFullYear() <= birthDate.getFullYear()) {
			setAgee(0);
		}

		if(year_born === null){
			console.log("yearrr", year_born);
			setAgee('');
			return false 
		}




		let earliestYear = 2003;

		

		var m = year_born.getMonth();
		// console.log("month is", m);
		// console.log("birth year is", birthDate.getFullYear());
		// console.log("birth month is", birthDate.getMonth());
		// console.log("birth Day is", birthDate.getDate());
		// console.log("Current Year is", currentDate.getFullYear());
		// console.log("Current Day is", currentDate.getDate());
		// console.log("earliest year is", earliestYear);
		// console.log("year born is", year_born);
		// console.log("year month is", year_born.getMonth());
		// console.log("current date is", currentDate);


		var n = currentDate.getMonth() - birthDate.getMonth();
		if (n < 0 || (n === 0 && currentDate.getDate() < birthDate.getDate())) 
		{
			if(birthDate.getFullYear() > currentDate.getFullYear()){
				console.log("testtt");

				age--;
			}
			else{
				age--;
			}
			setAgee(age);
			console.log("Real age is" , age);
		}
		
		return age;

		// if(birthDate.getMonth() > currentDate.getMonth()) {
		// 	birthDate.setFullYear(currentDate.getFullYear())
		//   } else if(birthDate.getMonth() < currentDate.getMonth()) {
		// 	birthDate.setFullYear(currentDate.getFullYear() + 1)
		//   }



		

		// if (age > 20) {
		// 	// console.log("Age is", age);
		// 	alert("You are Not Eligible");
		// 	setDob('');
		// 	setAgee('');
			
		// }

	}

	// const getAge = (dateString) => {
		
	// 	var today = new Date();
	// 	var birthDate = new Date(dateString);
	// 	var age = today.getFullYear() - birthDate.getFullYear();
	// 	var m = today.getMonth() - birthDate.getMonth();
	// 	if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) 
	// 	{
	// 		age--;
	// 	}
	// 	return age;
	// }

	const schools = () => {
		let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: schoolsApiurl,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            // setSchresult(response.data.data.items);
			setSchresult(response.data.data.sort((a, b) => a.name.localeCompare(b.name)))
            //console.log('schoolname',response.data.data)
           
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
	}

	const programs = () => {
		let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: foreignexchangelists+"/dropdown",

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setProgramresult(response.data.data.items);
           	//console.log('programs',response.data.data)
           
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
	}

	const [loadingBtn, setLoadingBtn] = useState(false)
	const [homeSchoolError, setHomeSchoolError] = useState(false)
	const [homeCityError, setHomeCityError] = useState(false)
	const [homeStateError, setHomeStateError] = useState(false)
	const [homeCountryError, setHomeCountryError] = useState(false)

	const [sevpSchoolError,setSevpSchoolError] = useState(false);
	const [sevpCityError,setSevpCityError] = useState(false);
	const [sevpStateError,setSevpStateError] = useState(false);
	const [sevpCountryError,setSevpCountryError] = useState(false);

	const [aesNameError,setAesNameError] = useState(false);
	const [aesCityError,setAesCityError] = useState(false);
	const [aesStateError,setAesStateError] = useState(false);
	const [aesCountryError,setAesCountryError] = useState(false);

	const [errorStatus1,setErrorStatus1] = useState(false);


	let onAddEligibility = (Location) => {

		setLoadingBtn(true)

		console.log("xfr", xfrtype)

		let error = 0;

		if(fname === '')
		{
			setFnameerror(true)
			setFNameExist(false)
			error =1;
		}else if(fname.length < 2)
		{
			setFNameExist(true)
			setFnameerror(false)
			error =1;
		}
		else
		{
			setFnameerror(false)
			setFNameExist(false)
			error =0;
		}
		if(lname === '')
		{
			setLnameerror(true)
			setLNameExist(false)
			error =1;
		}else if(lname.length < 2)
		{
			setLNameExist(true)
			setLnameerror(false)
			error = 1;
		}
		else
		{
			setLNameExist(false)
			setLnameerror(false)
			error =0;
		}
		if(dob === '')
		{
			setDoberror(true)
			error =1;
		}
		else
		{
			setDoberror(false)
			error =0;
		}
		if(gender === '')
		{
			setGendererror(true)
			error =1;
		}
		else
		{
			setGendererror(false)
			error =0;
		}
		if(grade === '')
		{
			setGradeerror(true)
			error =1;
		}
		else
		{
			setGradeerror(false)
			error =0;
		}
		if(year_8th === '')
		{
			setYear_8therror(true)
			error =1;
		}
		else
		{
			setYear_8therror(false)
			error =0;
		}
		if(year_9th === '')
		{
			setYear_9therror(true)
			error =1;
		}
		else
		{
			setYear_9therror(false)
			error =0;
		}

		// if(datetransfered === '')
		// {
		// 	setDatetransferederror(true)
		// 	error =1;
		// }
		// else
		// {
		// 	setDatetransferederror(false)
		// 	error =0;
		// }

		// if(datetransfered === '')
		// {
		// 	setDatetransferederror(true)
		// 	error =1;
		// }
		// else
		// {
		// 	setDatetransferederror(false)
		// 	error =0;
		// }
		if(unit === '')
		{
			setUniterror(true)
			error =1;
		}
		else
		{
			setUniterror(false)
			error =0;
		}
		if(schoollast === '')
		{
			setLastSchoolError(true)
			error =1;
		}
		else
		{
			setLastSchoolError(false)
			error =0;
		}

		let years9='';

		if(grade >= 9)
		{
			years9 = year_9th;

		}else{
			years9 = "NA";
		}

		if(xfrtype === '')
		{
			setAeserror(true)
			error =1;

		}else{
			setAeserror(false)
			error =0;
		}

		if(xfrtype === '')
		{
			setTypeerror(true)
			error =1;

		}else{
			setTypeerror(false)
			error =0;
		}
		if(international_school === '')
		{
			setInterSchool(true)
			error =1;

		}else{
			setInterSchool(false)
			error =0;
		}


		if(xfrtype === "YES"){

		if(status1 === 0 || status1 === null || status1 === '')
		{
			setErrorStatus1(true);
			error =1;
		}
		else{
			setErrorStatus1(false);
			error = 0; 
		}

		if(aes === 'YES' && aesCompleted === '') {
            setAesCompletedError(true);
            error = 1;
		} else {
			setAesCompletedError(false);
		}

		// Add validation for 8th grade student
		if(is8thGrade === '') {
			setIs8thGradeError(true);
			error = 1;
		} else {
			setIs8thGradeError(false);
		}

		// Add validation for 8th grade file upload (required if 8th grade student)
		if(is8thGrade === 'YES' && !fileUrl8th) {
			alert("8th grade students are required to upload a document");
			error = 1;
		}

		// Add validation for transfer student
		if(isTransferStudent === '') {
			setIsTransferStudentError(true);
			error = 1;
		} else {
			setIsTransferStudentError(false);
		}
	}


		if(status1 === 'HOME SCHOOL')
		{
			if(home_school ==='')
			{
				setHomeSchoolError(true)
				error =1;
			}else{
				setHomeSchoolError(false)
			}
			if(home_city ==='')
			{
				setHomeCityError(true)
				error =1;
			}else{
				setHomeCityError(false)
				error = 0;
			}
			if(home_state ==='')
			{
				setHomeStateError(true)
				error =1;
			}else{
				setHomeStateError(false)
				error = 0;
			}
			if(home_country ==='')
			{
				setHomeCountryError(true)
				error =1;
			}else{
				setHomeCountryError(false)
				error = 0;
			}

		}

		if(status1 === 'NON-MEMBER PRIVATE SCHOOL')
		{
			if(private_school_name ==='')
			{
				setHomeSchoolError(true)
				error =1;
			}else{
				setHomeSchoolError(false)
			}
			if(private_city ==='')
			{
				setHomeCityError(true)
				error =1;
			}else{
				setHomeCityError(false)
				error = 0;
			}
			if(private_state ==='')
			{
				setHomeStateError(true)
				error =1;
			}else{
				setHomeStateError(false)
				error = 0;
			}
			if(private_country ==='')
			{
				setHomeCountryError(true)
				error =1;
			}else{
				setHomeCountryError(false)
				error = 0;
			}

		}


		if(status1 === 'PUBLIC SCHOOL')
		{
			if(public_school_name ==='')
			{
				setHomeSchoolError(true)
				error =1;
			}else{
				setHomeSchoolError(false)
			}
			if(public_city ==='')
			{
				setHomeCityError(true)
				error =1;
			}else{
				setHomeCityError(false)
				error = 0;
			}
			if(public_state ==='')
			{
				setHomeStateError(true)
				error =1;
			}else{
				setHomeStateError(false)
				error = 0;
			}
			if(public_country ==='')
			{
				setHomeCountryError(true)
				error =1;
			}else{
				setHomeCountryError(false)
				error = 0;
			}

		}




		if(status1 === 'SEVP SCHOOL')
		{
			if(sevp_school ==='')
			{
				setSevpSchoolError(true)
				error =1;
			}else{
				setSevpSchoolError(false)
			}
			if(sevp_city ==='')
			{
				setSevpCityError(true)
				error =1;
			}else{
				setSevpCityError(false)
				error = 0;
			}
			if(sevp_state ==='')
			{
				setSevpStateError(true)
				error =1;
			}else{
				setSevpStateError(false)
				error = 0;
			}
			if(sevp_country ==='')
			{
				setSevpCountryError(true)
				error =1;
			}else{
				setSevpCountryError(false)
				error = 0;
			}

		}




		if(status1 === 'GISA/GIAA MEMBER SCHOOL'){
			if(schoollast === 0){
				setSchool_gisaerror(true)
				error = 1
			}else{
				setSchool_gisaerror(false)
				error =0
			}
		}

		if(status1 === 'VIA CSIET-APPROVED EXCHANGE PROGRAM'){
			if(csiet === ''){
				setSchool_gisaerror(true)
				error = 1
			}else{
				setSchool_gisaerror(false)
				error =0
			}
		}





		if(status1 === 'AES SCHOOL')
		{
			if(aesname ==='')
			{
				setAesNameError(true)
				error =1;
			}else{
				setAesNameError(false)
			}
			if(aescity ==='')
			{
				setAesCityError(true)
				error =1;
			}else{
				setAesCityError(false)
				error = 0;
			}
			if(aesstate ==='')
			{
				setAesStateError(true)
				error =1;
			}else{
				setAesStateError(false)
				error = 0;
			}
			if(aescountry ==='')
			{
				setAesCountryError(true)
				error =1;
			}else{
				setAesCountryError(false)
				error = 0;
			}

		}






		 if(error === 0)
		 {
			let token = "Bearer "+localStorage.getItem('token');
	
			
			const data = {
	
				school_id:id,
				first_name :fname,
				middle_name:mname,
				last_name:lname,
				dob:moment(dob).format('MM-DD-YYYY'),
				age:agee,
				gender:gender,
				current_grade:grade,
				year_8 :year_8th,
				year_9 :years9,
				
				units_passed:unit,
				date_transfered:moment(datetransfered).format('MM-DD-YYYY'),
				last_school:schoollast,

				public_school_name:public_school_name,
				public_city:public_city,
				public_state:public_country,
				public_country:public_country,

				private_school_name:private_school_name,
				private_city:private_city,
				private_state:private_state,
				private_country:private_country,

				home_school:home_school,
				home_city:home_city,
				home_state:home_state,
				home_country:home_country,

				sevp_school:sevp_school,
				sevp_city:sevp_city,
				sevp_state:sevp_state,
				sevp_country:sevp_country,

				aesname:aesname,
				aescity:aescity,
				aesstate:aesstate,
				aescountry:aescountry,

				csiet_foreign_exchange:csiet,
				//gisa_foreign_exchange:gisa,
				notes:notes,
				status:'ACTIVE',
				status1: status1,
				inactive_reason: inactive,
				deleted_reason: deleted, 
				aes_status: xfrtype,
				aes:aes,
				aesdrop:aesPre,
				international_school:international_school,
				fileURL:fileUp,
				aes_completed: aesCompleted,
				student_8th: is8thGrade,
				fileurl_8th: fileUrl8th,
				is_transfer_student: isTransferStudent
				
			}
			console.log('datas',data)
			const instance = axios.create({
	
				baseURL: eligibility+id,
	
				timeout: 1000000,
	
				headers: {'authorization': token}
	
			  });
			  
			  instance.post('',data).then((response) =>{
	
				console.log('resulsuccess',response.data.data.status)
				setLoadingBtn(false)
				
				let path = 'newPath'; 
				navigate("/school_list/athlet_list/"+id)



			   
			  }).catch((error) =>{


                if( error.response.data.error[1].status === "Invalid value" )
                    {
                        setStatusExist('Status is required')
                        console.log('error',error.response.data)
                    }
                else
                    {
                        console.log('errors',error.response.data.error[1])
                        setStatusExist(false)
                    }


			  });

		}


	}

	const SchoolView = () => {
		let token = "Bearer "+localStorage.getItem('token');
		
		const instance = axios.create({
	
			baseURL: schoolsurl+'/'+id,
	
			timeout: 1000000,
	
			headers: {'authorization': token}
	
		  });
		  
		  instance.get('').then((response) =>{
			setSchoolName(response.data.data);		   
		  }).catch((error) =>{ 
			
			console.log('error',error.message)
	
			//localStorage.removeItem('token')
			//navigate("/")
			
	
		  });
	}



	const [checkCofirmbtn, setCheckConfirmBtn] = useState(false);

	const checkCofirm = event => {
	  if (event.target.checked) {
		setCheckConfirmBtn(false)
	  } else {
		setCheckConfirmBtn(true)
	  }
	  setCheckConfirmBtn(current => !current);
	};


	const ageError =()=>{
		alert("Your age above 20")
	} 


	const changeHandler8th = (event) => {
		setFileSelect8th(event.name);

		let token = "Bearer " + localStorage.getItem('token');
		const data = new FormData();
		data.append('file', event);

		const instance = axios.create({
			baseURL: FileUploadAthletURL,
			timeout: 1000000,
			headers: {'authorization': token, "Content-Type": "multipart/form-data"},
		});

		instance.post('', data).then((response) => {
			console.log("8th grade file response", response.data);
			setFileUrl8th(response.data.Location);
		}).catch((error) => {     
			console.log('error', error.message);  
		});
	};
	const [fileUp, setFileUp] = useState('')

	const  changeHandler=(event)=>{

		setFileSelect(event.name)

		let token = "Bearer "+localStorage.getItem('token');

        const data = new FormData();

        data.append('file', event)

        const instance = axios.create({
            baseURL: FileUploadAthletURL,
            timeout: 1000000,
            headers: {'authorization': token, "Content-Type":  "multipart/form-data"},
        });


        instance.post('', data).then((response) =>{

			console.log("respooonse", response.data)
			setFileUp(response.data.Location)

        }).catch((error) =>{     
            console.log('error',error.message)  
        });

	}



    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    
                <div className="page-title-wrpr">
                    <div className="page-title-left-column">
                        
                        <h2 className="page-title">Add New Eligibility</h2>
                    </div>
                    <div className="page-rightside-action-column">
                        

                    </div>
                
                
                </div>

                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                        <li className="breadcrumb-item"><Link to={"/school_list/athlet_list/"+id}>Athletic Eligibility</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">Add New Eligibility</li>
                    </ol>
                </nav>


                <div className="form-wrpr">
					<div className="card formcard medium">
						<div className="card-body">
							
							<div className="form-group">
								<div className="row">
									<div className="col-md-6">
										<label >First Name:<span style={{color: "red"}}>*</span></label>
										<input type="text" className="form-control justshow bg-dark" value={fname} onChange={e => {setFname(e.target.value);setLoadingBtn(false)}}  placeholder="Enter First Name" />
										{
											fnameerror
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter first name</div>
											:null
                            			}
										{fnameexist?<div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>First name must be more than 2 characters.</div>:null}

									</div>
									<div className="col-md-6">
										<label >Middle Name:</label>
										
										<input type="text" className="form-control justshow bg-dark" value={mname} onChange={e => {setMname(e.target.value);setLoadingBtn(false)}}  placeholder="Enter Middle Name" />
										{/* {
											lnameerror
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter middle name</div>
											:null
                            			}
										{lnameexist?<div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>{lnameexist}</div>:null} */}
									</div>
									
								</div>
								
							</div>
							
							
							<div className="form-group">
								<div className="row">

								<div className="col-md-6">
										<label >Last Name:<span style={{color: "red"}}>*</span></label>
										
										<input type="text" className="form-control justshow bg-dark" value={lname} onChange={e => {setLname(e.target.value);setLoadingBtn(false)}}  placeholder="Enter Last Name" />
										{
											lnameerror
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter last name</div>
											:null
                            			}
										{/* {lnameexist?<div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>{lnameexist}</div>:null} */}
										{lnameexist?<div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Last name must be more than 2 characters.</div>:null}

									</div>
									
									
									<div className="col-md-6">
										<label >Gender<span style={{color: "red"}}>*</span></label>
										
										<select className="form-control justshow bg-dark " onChange={e => {setGender(e.target.value);setLoadingBtn(false)}}>
											<option value="">Select Gender</option>
											<option value="MALE">MALE</option>
											<option value="FEMALE">FEMALE</option>
										</select>
										{
											gendererror
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter gender</div>
											:null
                            			}
									</div>
								</div>
								
							</div>

							<div className="form-group">

								<div className="row">

									<div className="col-md-6">
											
										<label >Date of Birth<span style={{color: "red"}}>*</span></label>
											
										{/* <input type="text" className="form-control justshow bg-dark" value={dob} onChange={e => {setDob(e.target.value)}}  placeholder="Enter Date of Birth" /> */}
											
										<DatePicker
											className="form-control justshow bg-dark"
											selected={dob}
											onChange={(date) => age_calc(date)}
											value={dob}
											isClearable
											// onKeyDown={(e) => {
											// 	e.preventDefault();
											// }}
											// maxDate={moment(Date())}
											filterDate = {(date) => {
												return moment() > date;
											  }}
											placeholderText="Enter Date Of Birth (MM-DD-YY)"
											showMonthDropdown={true}
											showYearDropdown={true}
											scrollableYearDropdown={false}
										/>
											{
												doberror
												? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter date of birth</div>
												:null
											}
									</div>

									<div className="col-md-6">
										<label >Age:</label>
										
										<input type="text" className="form-control justshow bg-dark" disabled value={agee}  placeholder="Age" />
										{/* {
											lnameerror
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter middle name</div>
											:null
                            			}
										{lnameexist?<div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>{lnameexist}</div>:null} */}

									</div>

								</div>
								
							</div>

							
							
							
							<div className="form-group">
								<div className="row">
									
									<div className="col-md-6">
										<label >Grade Level Current School Year<span style={{color: "red"}}>*</span></label>
										
										<select className="form-control justshow bg-dark" onChange={e => { setGrade(e.target.value);setLoadingBtn(false) }}>
											<option>Select Grade Level<span style={{color: "red"}}>*</span></option>
											<option value="8">8</option>
											<option value="9">9</option>
											<option value="10">10</option>
											<option value="11">11</option>
											<option value="12">12</option>
										</select>
										{
											gradeerror
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter grade</div>
											:null
                            			}
									</div>
									<div className="col-md-6">
										<label >Year Entered 8th Grade<span style={{color: "red"}}>*</span></label>
										
										{/* <input type="text" className="form-control justshow bg-dark" value={year_8th} onChange={e => {setYear_8th(e.target.value)}}  placeholder="Enter Year Entered in 8th Grade" /> */}
										<select
											placeholder="Enter Year Entered in 8th Grade"
											id="date-dropdown"
											value={year_8th}
											className="form-control justshow bg-dark"
											onChange={({ target: { value } }) => setYear_8th(value)}
											onClick={()=> setLoadingBtn(false)}
										>
											<option value="0">Select Year</option>
										</select>

										{
											year_8therror
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter 8th grade</div>
											:null
                            			}
									</div>
								</div>
								
							</div>
							
							
							<div className="form-group">
								<div className="row">
									
									<div className="col-md-6">
										<label >Year Entered 9th Grade<span style={{color: "red"}}>*</span></label>
										
										{/* <input type="text" className="form-control justshow bg-dark" value={year_9th} onChange={e => {setYear_9th(e.target.value)}}  placeholder="Enter Year Entered in 9th Grade" /> */}

										{
											grade >= 9?
											(
												<select
													placeholder="Enter Year Entered in 9th Grade"
													id="date-dropdown2"
													value={year_9th}
													className="form-control justshow bg-dark"
													onChange={({ target: { value } }) => setYear_9th(value)}
													onClick={()=> setLoadingBtn(false)}
													>
												<option value="0">Select Year</option>
												</select>
											):
											(<input type="text" className="form-control justshow bg-dark" defaultValue="NA"  placeholder="Enter Year Entered in 9th Grade"/>)

										}
										
										
										{/* {
											year_9therror
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter 9th grade</div>
											:null
                            			} */}
									</div>

									<div className="col-md-6">
										<label >Date transfered to {decode(schoolName.name)}</label>
										{/* <input type="date" className="form-control justshow bg-dark" value={datetransfered} onChange={e => {setDatetransfered(e.target.value)}} /> */}

											<DatePicker
											className="form-control justshow bg-dark"
											selected={datetransfered}
											onChange={(date) => {setDatetransfered(date);setLoadingBtn(false)}}
											value={datetransfered}
											isClearable
											placeholderText="Date Transfered to (MM-DD-YYYY)"
										/>

										{/* {
											datetransferederror
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter date</div>
											:null
                            			}	 */}
									</div>

									{/* <div className="col-md-6">
										<label >GISA Schools <span style={{color: "red"}}>*</span></label>
										<select className="form-control justshow bg-dark" onChange={e => {setSchool_gisa(e.target.value)}}>
											<option>Select GISA School<span style={{color: "red"}}>*</span></option>
											{ schresult?.map((item,index)=>(
												<option key={index} value={item.id}>{item.name}</option>
											)
											
											) }
										</select>
										{
											school_gisaerror
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter gisa school</div>
											:null
                            			}
									</div> */}

								</div>
								
							</div>

							<div className="form-group">
								<div className="row">
								<div className="col-md-6">
										<label >Number of Units Passed Last Grading Period<span style={{color: "red"}}>*</span></label>
										<select className="form-control justshow bg-dark" onChange={e => {setUnit(e.target.value);setLoadingBtn(false)}}>
											<option>Select Unit</option>
											<option value="5">5</option>
											<option value="6">6</option>
											<option value="7">7</option>
											<option value="8">8</option>
											<option value="9">9</option>
											<option value="10">10</option>
										</select>
										{
											uniterror
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter unit</div>
											:null
                            			}	
									</div>

								</div>
							</div> 

							<div className="mb-5"></div> 

							<div className="form-group">
                                         
                                <div className="row">

                                    <div className="col-md-6">
                                            
									<label>Is this an AES (Homeschool) Student?<span style={{color: "red"}}>*</span></label>
                                            
                                            <div class="radio-btn-type">    
                                                
                                                <label>
                                                    
                                                    <input type="radio" 
                                                       
                                                        name="type1"
                                                        value="YES"
														// defaultValue={}
														onChange={e => {setAes(e.target.value);setLoadingBtn(false)}}
														/><span className="new-previous-label">Yes</span>
                                                
                                                </label>
                                                
                                                <label>
                                                    
                                                    <input type="radio" 
                                                         
                                                        name="type1"
                                                        value="NO"
														// defaultValue={}
                                                        onChange={e => {setAes(e.target.value);setLoadingBtn(false)}} 
														/><span className="new-previous-label">No</span>
                                                
                                                </label>

												
                                            </div>
											

											{
													aeserror?
													<div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please Select this is AES student or not</div>
													:null
												}
                                            

                                    </div>

                                </div>

                            </div>
	                        <div className="mb-5"></div> 

							{aes === 'YES' && (
								<div className="form-group">
									<div className="row">
										<div className="col-md-6">
											<label>Has this AES student application been completed and approved by the GIAA Office?<span style={{color: "red"}}>*</span></label>
											<div className="radio-btn-type">    
												<label>
													<input 
														type="radio" 
                                                        onClick={AEScompletedtrue}  

														name="aesCompleted"
														value="YES"
														
														onChange={e => {setAesCompleted(e.target.value); setLoadingBtn(false)}}
													/>
													<span className="new-previous-label">Yes</span>
												</label>
												
												<label>
													<input 
														type="radio" 
                                                        onClick={AEScompletedfalse}  

														name="aesCompleted"
														value="NO"
														onChange={e => {setAesCompleted(e.target.value); setLoadingBtn(false)}} 
													/>
													<span className="new-previous-label">No</span>
												</label>
											</div>
											{aesCompletedError && (
												<div className="nerrors" style={{color:"red", fontSize: "12.8px"}}>
													Please select if AES application has been completed
												</div>
											)}
										</div>
									</div>
								</div>
							)}

							 {/* {
								openXFR ?

									<div>
										<div className="mb-5"></div> 
										<label style={{fontSize: '14px'}}><a href="https://form.jotform.com/242213782125147">CLICK HERE</a> for AES Student Application Form</label>
									</div>

								:
									null
							} */}







							<div className="mb-5"></div> 

							<div className="form-group">
										
								<div className="row">

									<div className="col-md-6">
											
									<label>Is this an International Student?<span style={{color: "red"}}>*</span></label>
											
											<div class="radio-btn-type">    
												
												<label>
													
													<input type="radio" 
														name="type2"
														value="YES"
														onClick={openInter}
														// defaultValue={}
														onChange={e => {setInternational_school(e.target.value);setLoadingBtn(false)}}
														/><span className="new-previous-label">Yes</span>
												
												</label>
												
												<label>
													
													<input type="radio" 
														name="type2"
														onClick={closeInter}
														value="NO"
														// defaultValue={}
														onChange={e => {setInternational_school(e.target.value);setLoadingBtn(false)}} 
														/><span className="new-previous-label">No</span>
												
												</label>

												
											</div>

											{
													interschool?
													<div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please Select this is Insternational student or not</div>
													:null
												}
											

									</div>
									<div className="mb-5"></div> 



								</div>

							</div>
                            
							<div className="mb-5"></div> 
							



							{
								openInterSchoolForm ?

									<div>
										<div className="mb-5"></div> 
										<label style={{fontSize: '14px'}}><a href="https://form.jotform.com/242205730389153">CLICK HERE</a> for the International Student Application Form</label>
									</div>

								:
									null
							}

                          <div className="mb-5"></div>
                          <div className="form-group">
								<div className="row">
									<div className="col-md-6">
										<label>Is this an 8th grade student?<span style={{color: "red"}}>*</span></label>
										<div className="radio-btn-type">  
										
										   <label>
												<input 
													type="radio" 
													name="is8thGrade"
													value="NO"
													onChange={e => {setIs8thGrade(e.target.value); setLoadingBtn(false)}} 
												/>
												<span className="new-previous-label">No</span>
											</label>
											<label>
												<input 
													type="radio" 
													name="is8thGrade"
													value="YES"
													onChange={e => {setIs8thGrade(e.target.value); setLoadingBtn(false)}}
												/>
												<span className="new-previous-label">Yes</span>
											</label>
											
											
										</div>
										{is8thGradeError && (
											<div className="nerrors" style={{color:"red", fontSize: "12.8px"}}>
												Please select if this is an 8th grade student
											</div>
										)}
									</div>
								</div>
							</div>
							{is8thGrade === 'YES' && (
								<div className="form-group">
									<div className="row">
										<div className="col-md-12">	
											<label>Upload 8th Grade Document<span style={{color: "red"}}>*</span></label>	
											<div>
												<div className='file-input' style={{background:"#e6e8eaab", width:'100%'}}>
													<input 
														type='file' 
														onChange={(event) => {changeHandler8th(event.target.files[0]);}}  
													/>	
													<span className='button' style={{background:'dodgerblue', color:'#fff', fontWeight:'500', fontSize:'12px'}}>
														Choose
													</span>
													<span 
														className='labels' 
														style={{color: fileUrl8th ? 'dodgerblue' : 'gray', fontWeight:'500', fontSize:'12px'}} 
														data-js-label
													>
														{!fileSelect8th ? "No file selected" : fileSelect8th}
													</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							)}



							<div className="mb-5"></div> 

							<div className="form-group">
                                         
                                <div className="row">

                                    <div className="col-md-6">
                                            
									        <label>Was this student enrolled in your school LAST SCHOOL YEAR ?<span style={{color: "red"}}>*</span></label>
                                            
                                            <div class="radio-btn-type">    
                                                
                                                <label>
                                                    
                                                    <input type="radio" 
                                                        onClick={openType}  
                                                        name="type"
                                                        // onChange={e => {setType(e.target.value)}} 
														onChange={e => {setXfrType(e.target.value);setLoadingBtn(false)}} 
                                                        value="NO"/><span className="new-previous-label">Yes</span>
                                                
                                                </label>
                                                
                                                <label>
                                                    
                                                    <input type="radio" 
                                                        onClick={openSet}  
                                                        name="type" 
                                                        // onChange={e => {setType(e.target.value)}} 
														onChange={e => {setXfrType(e.target.value);setLoadingBtn(false)}} 
                                                        value="YES"/><span className="new-previous-label">No</span>
                                                
                                                </label>
                                            
                                            </div>
											{
												typeerror?
												<div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please Select the student enrolledin youre last school year or not</div>
												:null
											}

                                    </div>
									<div className="mb-5"></div> 



									

                                </div>

								

                            </div>
                            
									<div className="mb-5"></div> 

							{
								open ?
							
								<>
									<div className="mb-5"></div>
									
									<div className="form-group">
										<div className="row">
											<div className="col-md-12">

												<label >Where did the Student Transfer from ?</label>
													<div className="checkbox-wrpr">
														<select className="form-control bg-dark dark-theme showtext" onChange={e => {setStatus1(e.target.value);setLoadingBtn(false)
														setAesPre(e.target.value === 'AES SCHOOL'?"YES":"NO")}} id="status-selector">
															<option value="0">Where did the Student Transfer from ?</option>
															<option>GISA/GIAA MEMBER SCHOOL</option>
															<option>PUBLIC SCHOOL</option>
															<option>NON-MEMBER PRIVATE SCHOOL</option>
															<option>VIA CSIET-APPROVED EXCHANGE PROGRAM</option>
															<option value="HOME SCHOOL">HOME SCHOOL - NOW FULLY ENROLLED</option>
															<option value="SEVP SCHOOL">SEVP-CERTIFIED SCHOOL</option>
															<option value="AES SCHOOL">AES SCHOOL</option>


														</select>
													</div>
											</div>
										</div>
										
									</div> 
									{
										errorStatus1
										? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please select last school</div>
										:null
									}

									</> 
								
								:

								null

							}

										{ 
										
											status1 === 'GISA/GIAA MEMBER SCHOOL' ?	

											<div className="form-group">
												<div className="row">

													<div className="col-md-6">
														<label >GISA Schools </label>
														<select	select className="form-control justshow bg-dark" onChange={e => {setSchoollast(e.target.value);setLoadingBtn(false)}}>
														<option value=''>Select GISA School </option>
														{ schresult?.map((item,index)=>(
															<option key={index} value={item.id}>{decode(item.name)}</option>
														)
														
														) }
														</select>
													{
														school_gisaerror
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter gisa school</div>
														:null
													}
													</div>

												</div>

											</div>
												
											:
												
												null
										}

									{ 
										
										status1 === 'PUBLIC SCHOOL' ?	

										<>

										<div className="form-group">
											<div className="row">

											<div className="col-md-6">
											<label>Public School Name </label>
											<input type="text" className="form-control justshow bg-dark" value={public_school_name} onChange={e => {setPublic_school_name(e.target.value);setLoadingBtn(false)}}  placeholder="Enter Public school name" />
											{
												homeSchoolError
												? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Public school name</div>
												:null
											}
										{/* {lnameexist?<div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>{lnameexist}</div>:null}
										
											{
											school_gisaerror
											? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter gisa school</div>
											:null
										} */}
											</div>

											<div className="col-md-6">
												<label >City </label>
												<input type="text" className="form-control justshow bg-dark" value={public_city} onChange={e => {setPublic_city(e.target.value);setLoadingBtn(false)}}  placeholder="Enter City" />
												{
												homeCityError
												? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Public school city</div>
												:null
											}
											{/* {lnameexist?<div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>{lnameexist}</div>:null}
											
												{
												school_gisaerror
												? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter gisa school</div>
												:null
											} */}
											</div>

											</div>
										</div>
											
										
										<div className="form-group">
											<div className="row">
												<div className="col-md-6">
													<label >State </label>
													<input type="text" className="form-control justshow bg-dark" value={public_state} onChange={e => {setPublic_state(e.target.value);setLoadingBtn(false)}}  placeholder="Enter State" />
													{
												homeStateError
												? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Public school state</div>
												:null
											}
												{/* {lnameexist?<div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>{lnameexist}</div>:null}
												
													{
													school_gisaerror
													? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter gisa school</div>
													:null
												} */}
												</div>

												<div className="col-md-6">
													<label >Country </label>
													<input type="text" className="form-control justshow bg-dark" value={public_country} onChange={e => {setPublic_country(e.target.value);setLoadingBtn(false)}}  placeholder="Enter Country" />
													{
												homeCountryError
												? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Public school coutry</div>
												:null
											}
												{/* {lnameexist?<div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>{lnameexist}</div>:null}
												
													{
													school_gisaerror
													? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter gisa school</div>
													:null
												} */}
												</div>
											</div>
											</div>
										</>
											
										:
											
											null
										}

									{ 
										
										status1 === 'NON-MEMBER PRIVATE SCHOOL' ?	

										<>

											<div className="form-group">
												<div className="row">
											
													<div className="col-md-6">
														<label >Private School Name </label>
														<input type="text" className="form-control justshow bg-dark" value={private_school_name} onChange={e => {setPrivate_school_name(e.target.value);setLoadingBtn(false)}}  placeholder="Enter school name" />
														{
														homeSchoolError
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Non-member private school name</div>
														:null
														}
													</div>

													<div className="col-md-6">
														<label >City </label>
														<input type="text" className="form-control justshow bg-dark" value={private_city} onChange={e => {setPrivate_city(e.target.value);setLoadingBtn(false)}}  placeholder="Enter City" />
														{
														homeCityError
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Non-member private school city</div>
														:null
														}
													</div>

												</div>
											</div>

											<div className="form-group">
												<div className="row">

													<div className="col-md-6">
														<label >State </label>
														<input type="text" className="form-control justshow bg-dark" value={private_state} onChange={e => {setPrivate_state(e.target.value);setLoadingBtn(false)}}  placeholder="Enter State" />
														{
														homeStateError
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Non-member private school state</div>
														:null
														}
													</div>

													<div className="col-md-6">
														<label >Country </label>
														<input type="text" className="form-control justshow bg-dark" value={private_country} onChange={e => {setPrivate_country(e.target.value);setLoadingBtn(false)}}  placeholder="Enter Country" />
														{
														homeCountryError
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Non-member private school country</div>
														:null
														}
													</div>
												</div>
											</div>

										</>
											
										:
											
											null
										}
										{ 
										
										status1 === 'HOME SCHOOL' ?	

										<>

											<div className="form-group">
												<div className="row">
											
													<div className="col-md-6">
														<label >Home School Name </label>
														<input type="text" className="form-control justshow bg-dark" value={home_school} onChange={e => {setHome_school(e.target.value);setLoadingBtn(false)}}  placeholder="Enter school name" />
														{
														homeSchoolError
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Home school name</div>
														:null
													}
													</div>


													<div className="col-md-6">
														<label >City </label>
														<input type="text" className="form-control justshow bg-dark" value={home_city} onChange={e => {setHome_city(e.target.value);setLoadingBtn(false)}}  placeholder="Enter City" />
														{
														homeCityError
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Home school city</div>
														:null
													}
													</div>



												</div>
											</div>

											<div className="form-group">
												<div className="row">

													<div className="col-md-6">
														<label >State </label>
														<input type="text" className="form-control justshow bg-dark" value={home_state} onChange={e => {setHome_state(e.target.value);setLoadingBtn(false)}}  placeholder="Enter State" />
														{
														homeStateError
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Home state city</div>
														:null
														}
													</div>


													<div className="col-md-6">
														<label >Country </label>
														<input type="text" className="form-control justshow bg-dark" value={home_country} onChange={e => {setHome_country(e.target.value);setLoadingBtn(false)}}  placeholder="Enter Country" />
														{
														homeCountryError
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter Home country city</div>
														:null
														}
													</div>

												</div>
											</div>

										</>
											
										:
											
											null
										}

									{ 
										
										status1 === 'VIA CSIET-APPROVED EXCHANGE PROGRAM' ?
										
											<div className="form-group">
												<div className="row">
											
													<div className="col-md-6">
														<label >VIA CSIET-APPROVED EXCHANGE PROGRAM </label>
														<select	select className="form-control justshow bg-dark" onChange={e => {setCsiet(e.target.value);setLoadingBtn(false)}}>
														<option value=''>Select CSIET-APPROVED EXCHANGE PROGRAM<span style={{color: "red"}}>*</span></option>
														{ 
															programresult?.map((item,index)=>{
															if (item.type === "CSIT") {
																return (
															<option key={index} value={item.id}>{item.name}</option>)
															}
														}
														
														) }
														</select>
													{
														school_gisaerror
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter CSIET</div>
														:null
													}
													</div>

												</div>
											</div>
											
										:
											
											null
									}



									{ 
										
										status1 === 'SEVP SCHOOL' ?	

										<>

											<div className="form-group">
												<div className="row">
											
													<div className="col-md-6">
														<label >SEVP-CERTIFIED School Name </label>
														<input type="text" className="form-control justshow bg-dark" value={sevp_school} onChange={e => {setSevp_school(e.target.value);setLoadingBtn(false)}}  placeholder="Enter school name" />
														{
														sevpSchoolError
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter SEVP-CERTIFIED school name</div>
														:null
													}
													</div>


													<div className="col-md-6">
														<label >SEVP-CERTIFIED School City </label>
														<input type="text" className="form-control justshow bg-dark" value={sevp_city} onChange={e => {setSevp_city(e.target.value);setLoadingBtn(false)}}  placeholder="Enter City" />
														{
														sevpCityError
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter SEVP-CERTIFIED school city</div>
														:null
													}
													</div>



												</div>
											</div>

											<div className="form-group">
												<div className="row">

													<div className="col-md-6">
														<label >SEVP-CERTIFIED School State </label>
														<input type="text" className="form-control justshow bg-dark" value={sevp_state} onChange={e => {setSevp_state(e.target.value);setLoadingBtn(false)}}  placeholder="Enter State" />
														{
														sevpStateError
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter SEVP-CERTIFIED school city</div>
														:null
														}
													</div>


													<div className="col-md-6">
														<label >SEVP-CERTIFIED School Country </label>
														<input type="text" className="form-control justshow bg-dark" value={sevp_country} onChange={e => {setSevp_country(e.target.value);setLoadingBtn(false)}}  placeholder="Enter Country" />
														{
														sevpCountryError
														? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter SEVP-CERTIFIED school country</div>
														:null
														}
													</div>

												</div>
											</div>

										</>
											
										:
											
										null
									}


										{/* <label >&nbsp; </label>
										<div className="checkbox-wrpr">
											<input type="checkbox" onClick={openList} className="form-control justshow bg-dark" />
											<div class="chckc">
											<label >School Last Attended</label>
												<div className="info">Please select a school from the dropdown menu selection below -  OR - CSIET Approved foreign exchange program  the student last attended.  If the school is not
												listed in the dropdown menu selection, please enter the name, city and state of the school in the subsequent fields.
												</div>
											</div>
										</div>					 */}
								


								{
								status1 === 'AES SCHOOL' ?
								
								<div>

								<div className="form-group">
								<div className="row">

									<div className="col-md-6">
										<label>AES School Name</label>
										<input type="text" className="form-control justshow bg-dark" value={aesname} onChange={e => {setAesName(e.target.value);setLoadingBtn(false)}}  placeholder="Enter Name" />
										{
										aesNameError
										? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter AES School Name</div>
										:null
										}
									</div>


									<div className="col-md-6">
										<label >AES School City </label>
										<input type="text" className="form-control justshow bg-dark" value={aescity} onChange={e => {setAesCity(e.target.value);setLoadingBtn(false)}}  placeholder="Enter City" />
										{
										aesCityError
										? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter AES School City</div>
										:null
										}
									</div>

								</div>
								</div>

								<div className="form-group">

								<div className="row">

									<div className="col-md-6">
										<label >AES School State </label>
										<input type="text" className="form-control justshow bg-dark" value={aesstate} onChange={e => {setAesState(e.target.value);setLoadingBtn(false)}}  placeholder="Enter State" />
										{
										aesStateError
										? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter AES School city</div>
										:null
										}
									</div>


									<div className="col-md-6">
										<label >AES School Country </label>
										<input type="text" className="form-control justshow bg-dark" value={aescountry} onChange={e => {setAesCountry(e.target.value);setLoadingBtn(false)}}  placeholder="Enter Country" />
										{
										aesCountryError
										? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Please enter AES School country</div>
										:null
										}
									</div>

								</div>

								</div>
								</div>

								:
									null
								}

								
							
						<div className="mb-5"></div> 
							<div className="form-group">
										<div className="row">
											<div className="col-md-6">
												<label>Is this student a transfer student?<span style={{color: "red"}}>*</span></label>
												<div className="radio-btn-type">    
													<label>
														<input 
															type="radio" 
															name="isTransferStudent"
															value="YES"
															onChange={e => {setIsTransferStudent(e.target.value); setLoadingBtn(false)}}
														/>
														<span className="new-previous-label">Yes</span>
													</label>
													
													<label>
														<input 
															type="radio" 
															name="isTransferStudent"
															value="NO"
															onChange={e => {setIsTransferStudent(e.target.value); setLoadingBtn(false)}} 
														/>
														<span className="new-previous-label">No</span>
													</label>
												</div>
												{isTransferStudentError && (
													<div className="nerrors" style={{color:"red", fontSize: "12.8px"}}>
														Please select if this is a transfer student
													</div>
												)}
											</div>
										</div>
									</div>
							
                            <div className="mb-5"></div>
							<div className="form-group">
								<div className="row">
									<div className="col-md-12">	
										<label >Upload Document</label>	
										<div>
											<div class='file-input' style={{background:"#e6e8eaab", width:'100%'}}>
											<input type='file' onChange={(event)=>{changeHandler(event.target.files[0]);}}  />	
											<span class='button' style={{background:'dodgerblue', color:'#fff', fontWeight:'500', fontSize:'12px'}}>Choose</span>
											<span class='labels' style={{color:fileUp?'dodgerblue':'gray', fontWeight:'500', fontSize:'12px' }} data-js-label>{!fileSelect?"No file selected":fileSelect}</span>
											</div>
										</div>
									</div>
								</div>
							</div>



							
							<div className="form-group">
								<div className="row">
								{ status === 'INACTIVE' ?	
									<div className="col-md-6">
										<label >Inactive Reason </label>
										<div className="checkbox-wrpr">
											<select className="form-control bg-dark dark-theme showtext" onChange={e => {setInactive(e.target.value);setLoadingBtn(false)}} id="status-selector">
												<option value="0">Select Reason</option>
												<option value="Did not PASS enough credits this semester">Did not PASS enough credits this semester</option>
												<option value="Student is not competing in any sports">Student is not competing in any sports</option>
											</select>
										</div>	
									</div>:null
								}

								{ status === 'DELETED' ?	
									<div className="col-md-6">
										<label >Deleted Reason </label>
										<div className="checkbox-wrpr">
											<select className="form-control bg-dark dark-theme showtext" onChange={e => {setDeleted(e.target.value);setLoadingBtn(false)}} id="status-selector">
												<option value="0">Select Reason</option>
												<option value="Student no longer attends this school">Student no longer attends this school</option>												{/* <option onClick={DeleteReason} value="DELETED">DELETED</option> */}
											</select>
										</div>	
									</div>:null
								}



									<div className="col-md-6">

										<label >Notes</label>
										<textarea type="text" className="form-control justshow bg-dark" value={notes} onChange={e => {setNotes(e.target.value);setLoadingBtn(false)}}  placeholder="Enter Notes" />
									</div>


									<div className="col-md-6">
										{/* <label >Status <span style={{color: "red"}}>*</span></label>
										<div className="checkbox-wrpr">
											<select className="form-control bg-dark dark-theme showtext" onChange={e => {setStatus(e.target.value)}} id="status-selector">
												<option value="0">Select Status</option>
												<option value="ACTIVE">ACTIVE</option>
												<option value="INACTIVE">INACTIVE</option>
												<option value="DELETED">DELETED</option>
											</select>
											{statusexist?<div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>{statusexist}</div>:null}

										</div>	 */}
									</div>	

								</div>
							</div>
						

							<h6 style={{color: "red"}}>* Required Fields</h6>
							<div className="form-group">
								<div className="row">
		
									<div className="col-md-6">
										<label >&nbsp; </label>
										<div className="checkbox-wrpr">
											<input type="checkbox" 
												onChange={checkCofirm}
												className="form-control justshow bg-dark" />
											<div class="chckc">
											By checking this box, I confirm that the information entered above is true and accurate. I also confirm that this student has NOT attended another GISA/GIAA Member School within the last 12 months. 
											</div>
										</div>					
									</div>
								</div>
							</div>
							<div className="form-group text-right">
							<button className="btn btn-danger btn-gisa" onClick={RoutToList} type="submit">Cancel</button>
								{checkCofirmbtn?
								<Fragment>									
								{agee < 20?
										<Fragment>
											{loadingBtn?
												<button onClick={onAddEligibility} disabled className="btn btn-primary btn-gisa" type="button">Loading</button>:
												<button onClick={onAddEligibility} className="btn btn-primary btn-gisa" type="button">Create </button>
											}
										</Fragment>:
										<button onClick={ageError} className="btn btn-primary btn-gisa" type="button">Create</button>
								}
								</Fragment>:
								<Fragment>
									<button onClick={onAddEligibility} disabled className="btn btn-primary btn-gisa" type="button">Create </button>
								</Fragment>
								}
							</div>
						</div>
					</div>
					
				</div>
                </div>
            </aside>
        </div>
    )
}

export default AddAthlet;
